module.exports = __webpack_public_path__ + "static/media/Lato-Bold.85d339d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Lato/Lato-Bold.ttf
// module id = 296
// module chunks = 0